import { useSelector } from 'react-redux'
import { useQuery } from 'react-query'
import sortBy from 'lodash/sortBy'
import { useCoreContext } from 'lib/core/hooks'
import { fetchProducts } from 'lib/modules/catalog'
import { getProductAttributeList } from 'lib/core/data/common/productAttributeList/selectors'
import { RootState } from 'lib/core/data/reducer'

interface Params {
  sku?: string[]
}

export const useProductsBySku = (params?: Params) => {
  const { magentoClient } = useCoreContext()
  const productAttrList = useSelector(getProductAttributeList)
  const storeConfig = useSelector((state: RootState) => state.common.storeConfig.payload)
  const skus = sortBy(params?.sku)

  const { isError, isFetching, isLoading, data: products } = useQuery(
    ['useProductsBySku', skus], async () => {
      return fetchProducts({
        skus,
        magentoClient,
        productAttrList: productAttrList,
        storeConfig
      })
    }, {
      enabled: Boolean(params?.sku?.length)
    }
  )

  return {
    isError,
    isFetching,
    isLoading,
    products
  }
}
